
class PricingService {
  constructor() {
    this.baseURL = process.env.REACT_APP_API_URL
      ? `${process.env.REACT_APP_API_URL.replace('/api/api', '/api/pricing')}`
      : '/api/pricing';
  }

  async getPricingTiers() {
    try {
      const response = await fetch(`${this.baseURL}/tiers`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data.tiers;
    } catch (error) {
      console.error('Error fetching pricing tiers:', error);
      throw error;
    }
  }

  async getUserSubscription(idToken) {
    try {
      const response = await fetch(`${this.baseURL}/subscription`, {
        headers: {
          'Authorization': `Bearer ${idToken}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data.subscription;
    } catch (error) {
      console.error('Error fetching user subscription:', error);
      throw error;
    }
  }

  async checkUserLimits(idToken, action) {
    try {
      const response = await fetch(`${this.baseURL}/check-limits`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${idToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ action })
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error checking user limits:', error);
      throw error;
    }
  }

  async createUpgradeSession(idToken, tier) {
    try {
      const response = await fetch(`${this.baseURL}/upgrade`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${idToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ tier })
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error creating upgrade session:', error);
      throw error;
    }
  }

  async cancelSubscription(idToken) {
    try {
      const response = await fetch(`${this.baseURL}/cancel`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${idToken}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error canceling subscription:', error);
      throw error;
    }
  }

  async getUserUsage(idToken) {
    try {
      const response = await fetch(`${this.baseURL}/usage`, {
        headers: {
          'Authorization': `Bearer ${idToken}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data.usage;
    } catch (error) {
      console.error('Error fetching user usage:', error);
      throw error;
    }
  }

  formatTimeRemaining(minutes) {
    if (minutes < 60) {
      return `${minutes}m`;
    } else if (minutes < 1440) {
      const hours = Math.floor(minutes / 60);
      const mins = minutes % 60;
      return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
    } else {
      const days = Math.floor(minutes / 1440);
      const hours = Math.floor((minutes % 1440) / 60);
      return hours > 0 ? `${days}d ${hours}h` : `${days}d`;
    }
  }

  getTierColor(tier) {
    const colors = {
      free: '#6B7280',
      premium: '#3B82F6',
      pro: '#8B5CF6'
    };
    return colors[tier] || colors.free;
  }

  getTierBadge(tier) {
    const badges = {
      free: '🆓',
      premium: '⭐',
      pro: '💎'
    };
    return badges[tier] || badges.free;
  }
}

export const pricingService = new PricingService();
export default pricingService;